import React from 'react'
import _ from 'lodash'
// Styles
import styles from './section.module.scss'

interface SectionProps {
  children?: React.ReactNode
  styleModifiers?: string[]
  marginTopOverride?: number | null
  marginBottomOverride?: number | null
}

const Section = ({
  children,
  styleModifiers = [],
  marginTopOverride = null,
  marginBottomOverride = null,
}: SectionProps): React.ReactElement => {
  const className = (styleModifiers?.length) ? `${styles.section} ${_.map(styleModifiers, modifier => styles[modifier]).join(' ')}` : styles.section
  const elementTypeModifier = styleModifiers && _.find(styleModifiers, modifier => {
    return (
      modifier === '--is-main'
      || modifier === '--is-nav'
      || modifier === '--is-footer'
      || modifier === '--is-div'
    )
  })

  const style: React.CSSProperties = {}
  if (typeof marginTopOverride === 'number') style.marginTop = `${marginTopOverride}px`
  if (typeof marginBottomOverride === 'number') style.marginBottom = `${marginBottomOverride}px`

  let elementType: 'section' | 'nav' | 'footer' | 'div' = 'section'
  const elementAttributes: React.HTMLAttributes<HTMLElement> = {className}
  if (!_.isEmpty(style)) {
    elementAttributes.style = style
  }

  if (elementTypeModifier) {
    if (elementTypeModifier.slice(5) === 'main') {
      elementType = 'div'
      elementAttributes.role = 'main'
    } else {
      elementType = elementTypeModifier.slice(5) as 'section' | 'nav' | 'footer' | 'div'
    }
  }

  return React.createElement(elementType, elementAttributes, children)
}

export default Section
